import React, { useState, useEffect, useContext } from 'react'
import { Button, Col, Divider, Drawer, Input, message, Row, Select, Transfer, Typography } from 'antd'
import Utils from '../../../utils/Utils'
import userSrc from '../userSrc'
import { Context } from '../../../context'

const { Title } = Typography

function UserDrawerMultiempresa(props) {
  const [{ auth }] = useContext(Context)
  const [loadingTransferData, setLoadingTransferData] = useState(true)
  const [loading, setLoading] = useState(true)
  const [companyId, setCompanyId] = useState(null)
  const [enterprises, setEnterprises] = useState([])
  const [targetKeys, setTargetKeys] = useState([])
  const [targetKeysCompanies, setTargetKeysCompanies] = useState([])
  const [storeData, setStoreData] = useState([])

  const loadUserInformation = () => {
    setCompanyId(props.edit ? props.editData._empresa : null)

    // if (props.edit) getStores(props.editData._empresa)
  }

  useEffect(() => {
    if (props.visible) {
      newGetStores(targetKeysCompanies)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetKeysCompanies])

  useEffect(() => {
    loadUserInformation()
    if (props.visible) {
      onSearchEnterprise(props.edit ? props.editData._empresaNombre : '')
      const targetKeyCompanyAux = props.editData.companies.map(item => {
        return item.id
      })
      const targetKeyAux = props.editData._stores_ids.map(item => {
        return item.id
      })
      setTargetKeysCompanies(props.edit ? targetKeyCompanyAux : [])
      setTargetKeys(props.edit ? targetKeyAux : [])
      
      if (auth.role_id !== 1) {
        setCompanyId(auth.company_id)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible, props.editData])

  const onSearchEnterprise = val => {
    val !== null ? (val = '') : (val = '')

    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getEnterpriseOption(val, excludeChars, 'desc')
      .then(response => {
        var res = response.data.data.map(x => {
          const obj = {
            key: x.id,
            name: x.name
          }

          return obj;
        });

        setEnterprises(res)
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de empresa')
      })
  }

  const onChangeTransferCompanies = targetKeys => {
    setTargetKeysCompanies(targetKeys)
  }

  const onChangeTransfer = targetKeys => {
    setTargetKeys(targetKeys)
  }

  const newGetStores = ids => {
    setLoadingTransferData(true)
    const arrayStore = ids.map(async id => {
      const getStoreData = await userSrc.getStoreOption(id)      
      return getStoreData.data.data;
    })

    Promise.all(arrayStore).then(data => {      

      let storeDataAux = []
      data.forEach(element => {
        element.forEach(item => {
          const obj = {
            key: item.id,
            title: item.name
          }

          storeDataAux.push(obj)
        });
      });

      setStoreData(storeDataAux)
      setLoadingTransferData(false)
    });
  }

  const saveData = () => {
    let requestData

    let id = props.editData ? props.editData._id : null
    let level = props.editData ? props.editData.level : null
    requestData = {
      level: level,
      companies: targetKeysCompanies,
      stores: targetKeys,
    }

    const method = props.edit ? 4 : 3
    props.saveButton(requestData, id, method)
  }

  return (
    <Drawer placement="right" closable={false} onClose={props.closable} visible={props.visible} width={800}>
      <Title> {props.edit ? 'Editar Usuario' : 'Nuevo Usuario'} </Title>
      <Divider className={'divider-cxustom-margins-users'} />
      <Row gutter={16} className={'section-space-field'}>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className={'title-space-field'}>Nombre*</div>
          <Input disabled={true} value={props.editData?._name} placeholder={'Nombre'} size={'large'} />
        </Col>
      </Row>
      
      <Row gutter={16} className={'section-space-list'}>
        <Col xs={12} sm={12} md={12} lg={12}>
          <span className={'label-bold-500'} style={{ marginLeft: '10px' }}>
            Empresas disponibles
          </span>
        </Col>
        <Col xs={12} sm={12} md={12} lg={12}>
          <span className={'label-bold-500'} style={{ marginLeft: '20px' }}>
            Empresas asignadas al usuario
          </span>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Transfer
            disabled={loading}
            dataSource={enterprises}
            showSearch
            listStyle={{
              width: '100%',
              height: 250,
            }}
            targetKeys={targetKeysCompanies}
            onChange={onChangeTransferCompanies}
            render={item => `${item.name}`}
          />
        </Col>
      </Row>
      <Row gutter={16} className={'section-space-list'}>
        <Col xs={12} sm={12} md={12} lg={12}>
          <span className={'label-bold-500'} style={{ marginLeft: '10px' }}>
            Tiendas disponibles
          </span>
        </Col>
        <Col xs={12} sm={12} md={12} lg={12}>
          <span className={'label-bold-500'} style={{ marginLeft: '20px' }}>
            Tiendas asignadas al usuario
          </span>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Transfer
            disabled={loadingTransferData}
            dataSource={storeData}
            showSearch
            listStyle={{
              width: '100%',
              height: 250,
            }}
            targetKeys={targetKeys}
            onChange={onChangeTransfer}
            render={item => `${item.title}`}
          />
        </Col>
      </Row>
      <Divider className={'divider-custom-margins-users'} />
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <div className="text-right">
            <div>
              <Button type={'link'} onClick={() => props.cancelButton()} className="cancel-button">
                Cancelar
              </Button>

              <Button className="title-tendero new-button" onClick={() => saveData()}>
                Guardar
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </Drawer>
  )
}

export default UserDrawerMultiempresa
